// extracted by mini-css-extract-plugin
module.exports = {"main":"layout-module--main--1lXwd","mode_white":"layout-module--mode_white--3AC0C","mode_black":"layout-module--mode_black--3BbSJ"};